<div class="view-container">
  <mat-card class="individual-list-container">
    <div class="individual-list__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>people</mat-icon>
        </div>
        <h1 class="mbp-page-header__title">Individuals</h1>
      </div>

      <form class="individual-list__filters" [formGroup]="individualFilterForm">
        <mat-form-field appearance="outline" class="individual-list__filter individual-list__filter--search" subscriptSizing="dynamic">
          <input type="text" formControlName="search" matInput placeholder="Search individuals" />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="individual-list__filter individual-list__filter--type" subscriptSizing="dynamic">
          <mat-label>Individual type</mat-label>
          <mat-select [formControl]="individualType">
            <mat-option [value]="allIndividualTypes">All</mat-option>
            @for (type of individualTypes; track type) {
              <mat-option [value]="type.code">
                {{ type.type }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </div>

    <mat-paginator
      class="individual-list__paginator"
      [length]="totalNumberOfIndividuals"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [pageSizeOptions]="[10, 15, 20]"
      showFirstLastButtons
      (page)="onPageChange($event)"
      aria-label="Select page of individuals"
    >
    </mat-paginator>

    <div class="mbp-table-wrap">
      <table
        mat-table
        [dataSource]="individualsDataSource"
        matSort
        (matSortChange)="sortIndividuals($event)"
        class="mbp-data-table individual-list"
      >
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let individual">{{ individual.title }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by Name"
            start="desc"
            class="name-col"
          >
            Name
          </th>
          <td mat-cell *matCellDef="let individual" class="name-col">
            {{ individual.first_name + ' ' + individual.last_name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let individual">{{ getIndividualType(individual) }}</td>
        </ng-container>

        <ng-container matColumnDef="contact">
          <th mat-header-cell *matHeaderCellDef>Contact</th>
          <td mat-cell *matCellDef="let individual">{{ individual.phone_number }}</td>
        </ng-container>

        <ng-container matColumnDef="sage">
          <th mat-header-cell *matHeaderCellDef>Sage</th>
          <td mat-cell *matCellDef="let individual">
            @if (isOnSage(individual)) {
              <span class="individual-list__sage individual-list__sage--synced">On Sage</span>
            } @else {
              <span class="individual-list__sage">Not on Sage</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let individual">{{ getCreationTime(individual) }}</td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let individual">{{ formatTime(individual.updated_at) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          (click)="viewIndividual(row.id)"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
  </mat-card>
</div>
